<template>
  <a
    ref="toggleDesc"
    href="javascript:;"
    class="toggle-desc"
    @click.stop="toggleDesc"
  >
    <slot>
      <i
        v-if="show"
        key="arrows"
        class="iconfont icon-arrows_up"
      />
      <i
        v-else
        key="arrows"
        class="iconfont icon-arrows_down"
      />
    </slot>
  </a>
</template>

<script>
  export default {
    data() {
      return {
        show: false
      }
    },
    methods: {
      toggleDesc () {
        this.show = !this.show;
        this.$emit('toggle', this.$refs.toggleDesc);
      }
    }
  }
</script>

<style scoped>
  @import 'variable';

  /*.toggle-desc {
    overflow: hidden;
    position: relative;
    display: block;
    height: 22px;
    text-align: center;
    .inner {
      z-index: 1;
      position: absolute;
      bottom: -26px;
      left: 50%;
      transform: translateX(-50%);
      width: 43px;
      height: 43px;
      border-radius: 100px;
    }
    .icon-arrows_down, .icon-arrows_up {
      color: var(--white-color);
      font-weight: bold;
      font-size: 12px;
    }
  }*/

  /* v1 */
  .toggle-desc {
    position: relative;
    display: block;
    height: 22px;
    padding-top: 10px;
    text-align: center;
    outline: none;
    font-size: 16px;
    .icon-arrows_down, .icon-arrows_up {
      font-weight: bold;
    }
  }
</style>